import { trigger, state, animate, transition, style } from '@angular/animations';

export class Animations{

  public static slideInOut = trigger(
    'slideInOut', [
      state('true', style({ height: '0px', overflow: 'hidden', opacity: 0 })),
      state('false', style({ height: '*', opacity: 1 })),
      transition('1 => 0', animate('250ms ease-in-out')),
      transition('0 => 1', animate('250ms ease-in-out'))
  ]);

  public static fadeInOut = trigger(
    'fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate('200ms ease-in-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(0, style({ opacity: 0 }))
      ])
    ]);

  public static fadeOut = trigger(
    'fadeOut', [
      transition(':leave', [   // :enter is alias to 'void => *'
        style({ opacity: 1 }),
        animate('300ms ease-in-out', style({ opacity: 0 }))
      ])
    ]);

  public static popOut = trigger(
    'popOut', [
      state('true', style({
        display: 'block',
        position: 'absolute',
        zIndex: 999,
        top: '0',
        left: '0',
        right: '0',
      })),
      state('false', style({ display: 'none', })),

    ]
  );

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/animations/animations.ts